import HttpRequest from "./http_request";

class LmgProvider extends HttpRequest {

	// Branch
    BranchCreate(data) {
        return this.post("branch", data);
    }
    BranchUpdate(id,data) {
        return this.put("branch/" + id, data);
    }
    BranchList(data) {
        return this.get("branch", data);
    }

    // User
    UserCreate(data) {
        return this.post("user", data);
    }
    UserChangePassword(data) {
        return this.put("user/password", data);
    }
    UserChangePasswordByAdmin(id,data) {
        return this.put("user/password/" + id, data);
    }
    UserSetActive(id,data) {
        return this.put("user/active/" + id, data);
    }
    UserList(data) {
        return this.get("user", data);
    }

    // insurance type
    InsuranceCreate(data) {
        // return this.post("insurance", data);
        return this.post("v2/insurance", data);
    }
    InsuranceUpdate(id,data) {
        // return this.put("insurance/" + id, data);
        return this.put("v2/insurance/" + id, data);
    }

    InsuranceDelete(id,data) {
        // return this.put("insurance/" + id, data);
        return this.delete("v2/insurance/" + id, data);
    }
    InsuranceList(data) {
        return this.get("v2/insurance", data);
    }

    InsuranceListUpper(data){
        return this.get("v2/insurance/upper", data);
    }

    

    // TType  (ประเภทตัวแทน)
    TTypeCreate(data) {
        return this.post("ttype", data);
    }
    TTypeUpdate(id,data) {
        return this.put("ttype/" + id, data);
    }
    TTypeList(data) {
        return this.get("ttype", data);
    }
    TTypeCodeList(data) {
        return this.get("code", data);
    }

    // Person
    PersonGetImage(data){
        return this.get("v2/person/photo/base64?id=" + data);
    }

    PersonCreate(data) {
        return this.postFormData("v2/person", data);
    }
    PersonUpdate(id,data) {
        return this.putFormData("v2/person/" + id, data);
    }
    PersonUpdateCredit(id,data) {
        return this.put("person/credit/" + id, data);
    }
    PersonList(data) {
        return this.get("v2/person", data);
    }

    PersonListNoLogin(data) {
        return this.get("person/nologin", data);
    }

    

    // Commision Profile
    CommCreate(data) {
        return this.post("comProfile", data);
    }
    CommUpdate(id,data) {
        return this.put("comProfile/" + id, data);
    }
    CommDelete(id) {
        return this.delete("comProfile/" + id);
    }
    CommList(data) {
        return this.get("comProfile", data);
    }

    CommExtraList(data) {
        return this.get("comProfile/extra?comprofileID="+ data);
    }

    CommUpdateExtraDataByPerson(data) {
        return this.post("comProfile/extra/adj", data);
    }

    CommExtraListByPerson(data) {
        return this.get("comProfile/person?personID="+ data);
    }

    CommExtraCreate(data) {
        return this.post("comProfile/extra", data);
    }
    CommExtraDelete(id) {
        return this.delete("comProfile/extra/" + id);
    }



    // Bank
    BankCreate(data) {
        return this.post("bank", data);
    }
    BankUpdate(id,data) {
        return this.put("bank/" + id, data);
    }
    BankDelete(id) {
        return this.delete("bank/" + id);
    }
    BankList(data) {
        return this.get("bank", data);
    }

    // Transaction
    TransactionCreate(data) {
        return this.postFormData("v4/transaction", data);
    }
    TransactionList(data) {
        return this.get("v4/transaction", data);
    }
	TransactionCancel(data) {
        return this.postJson("v4/transaction/cancel", data);
    }

	TransactionByListID(data){
		return this.postJson("v4/transaction/list", data);
	}

	TransactionCancelList(data) {
        return this.get("v4/transaction/cancel", data);
    }

    
    TransactionCalCommision(data) {
        return this.get("comProfile/cal", data);
    }

    // Payment
    PaymentCreate(data) {
        return this.postFormData("payment", data);
    }
    PaymentList(data) {
        return this.get("payment", data);
    }
    // โยกเงินสดที่พนักงานรับมา
    PaymentClearCreate(data){
        return this.post("payment/clear", data);
    }
    PaymentClearList(data){
        return this.get("payment/clear", data);
    }
    // เงินสดในสาขา
    PaymentBranchCash(data){
        return this.get("payment/branch/cash", data);
    }
    PaymentBranchTransferCreate(data){
        return this.post("payment/branch/cash/tranfer", data);
    }
    PaymentBranchTransferList(data){
        return this.get("payment/branch/cash/tranfer/log", data);
    }
    PaymentImage(data){
        return this.get_array_buffer("payment/tfimage?id="+ data);
    }


    // Billing
    BillingCreate(data) {
        return this.postFormData("billing/payment", data);
    }
    BillingList(data) {
        return this.get("billing", data);
    }

    BillingReportList(data) {
        return this.get("billing/duedate/summary", data);
    }

	// // Invoice
    InvoiceCreate(data) {
        return this.postJson("invoice", data);
    }
	InvoicePaid(data) {
        return this.postFormData("invoice/pay", data);
    }
    InvoiceList(data) {
        return this.get("invoice", data);
    }
	InvoiceBillingList(data) {
        return this.get("billing/choose", data);
    }
	InvoiceReport(data) {
        return this.get_blob("report/invoice", data);
    }




    // Customer
    CustomerCreate(data) {
        return this.post("v2/customer", data);
    }

    CustomerList(data) {
        return this.get("v2/customer", data);
    }

    CustomerUpdate(id,data) {
        return this.put("v2/customer/" + id, data);
    }

    CustomerCheckID(data) {
        return this.get("v2/customer/id/check", data);
    }

    GetAPIVersion(){
        return this.get("version" );
    }

    ReportDiscount(data){
        return this.get_blob("report/discount",data );
    }

    ReportTaxDiscount(data){
        return this.get_blob("report/wht",data );
    }


	// Address
	AddressProvinces(data) {
        return this.get("cities/province", data);
    }
	AddressDistrict(data) {
        return this.get("cities/district", data);
    }
	AddressSubDistrict(data) {
        return this.get("cities/subdistrict", data);
    }


	WhtList(data){
		return this.get("wht",data);
	}

	WhtExport(data){
		return this.get_blob("wht/export",data);
	}

	WhtCreate(data){
		return this.postJson("wht",data);
	}

}

export default LmgProvider;
